import React, { useState } from 'react';
import { toast } from 'react-toastify';
import axiosInstance from 'apis/axiosConfig';
import { useNavigate } from 'react-router-dom';

const AddLoanProvider = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();

    const handleCreateProvider = async (e) => {
        e.preventDefault();
        if (!name.trim() || !email.trim() || !password.trim()) {
            toast.warning("All fields are required!");
            return;
        }

        setSubmitting(true);
        try {
            await axiosInstance.post('loan-providers', {
                name: name.trim(),
                email: email.trim(),
                password: password.trim()
            });
            toast.success("Loan Provider created successfully!");
            navigate('/loan-providers');
        } catch (err) {
            console.error("Create provider failed:", err);
            const errMsg = err.response?.data?.message || "Failed to create loan provider.";
            toast.error(errMsg);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="container-fluid mt-4 mb-5" style={{ fontFamily: "'Inter', 'Roboto', sans-serif" }}>
            <div className="mb-4 px-2 d-flex justify-content-between align-items-center">
                <div>
                    <span className="badge px-3 py-1 mb-2 font-weight-bold" style={{ borderRadius: '8px', backgroundColor: '#F3E8FF', color: '#7E22CE' }}>
                        SYSTEM SECURITY ACCESS CONTROL
                    </span>
                    <h2 className="font-weight-bold mb-1" style={{ color: '#0F172A' }}>Add New Loan Provider</h2>
                    <p className="mb-0 text-muted" style={{ fontSize: '14px' }}>Onboard a new Loan Provider to the system.</p>
                </div>
                <button 
                    className="btn btn-outline-secondary font-weight-bold px-3 py-1 shadow-sm"
                    onClick={() => navigate('/loan-providers')}
                    style={{ borderRadius: '8px', fontSize: '13px' }}
                >
                    ← Back to List
                </button>
            </div>

            <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-8 col-md-12 mb-4">
                    <div className="card border-0 shadow-sm bg-white p-4" style={{ borderRadius: '20px' }}>
                        <h4 className="font-weight-bold text-dark mb-4">Onboard New Provider</h4>
                        <form onSubmit={handleCreateProvider}>
                            <div className="form-group mb-3">
                                <label htmlFor="providerName" className="font-weight-bold text-secondary mb-1">Provider Full Name</label>
                                <input 
                                    id="providerName"
                                    type="text" 
                                    className="form-control" 
                                    placeholder="Enter full provider name..."
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    style={{ borderRadius: '10px', padding: '10px 15px' }}
                                />
                            </div>
                            <div className="form-group mb-3">
                                <label htmlFor="providerEmail" className="font-weight-bold text-secondary mb-1">Email / Username</label>
                                <input 
                                    id="providerEmail"
                                    type="email" 
                                    className="form-control" 
                                    placeholder="Enter login email address..."
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    style={{ borderRadius: '10px', padding: '10px 15px' }}
                                />
                            </div>
                            <div className="form-group mb-4">
                                <label htmlFor="providerPassword" className="font-weight-bold text-secondary mb-1">Login Password</label>
                                <input 
                                    id="providerPassword"
                                    type="password" 
                                    className="form-control" 
                                    placeholder="Create secure password..."
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    style={{ borderRadius: '10px', padding: '10px 15px' }}
                                />
                            </div>
                            <button 
                                type="submit" 
                                className="btn btn-primary btn-block font-weight-bold py-2 shadow-sm"
                                disabled={submitting}
                                style={{ borderRadius: '12px', background: 'linear-gradient(90deg, #0EA5A4 0%, #0B4F6C 100%)', border: 0 }}
                            >
                                {submitting ? 'Registering...' : 'Add Loan Provider'}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddLoanProvider;

